import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/vsts/work/1/s/src/app/[[...slug]]/template-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnlineCatalogAssets"] */ "/home/vsts/work/1/s/src/components/ContentElementsGdds/online-catalog-assets/online-catalog-assets.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useIsoLang"] */ "/home/vsts/work/1/s/src/scenes/MetaData.tsx");
